import { TooltipWrapper } from 'components/TooltipWrapper'
import { useRolodexEdit } from 'features/fde'
import { useFeatureInteractionContext } from 'features/siteMap/contexts/FeatureInteractionContext'
import { useSiteModelContext } from 'features/siteMap/contexts/SiteModelContext'
import { Trash2Icon } from 'lucide-react'
import React, { FC } from 'react'
import styled from 'styled-components'
import { SiteFeaturePrimitive } from 'types'

const DeleteButton = styled.div`
  position: absolute;
  left: 8px;
  bottom: 8px;

  cursor: pointer;
  display: flex;
  justify-content: left;
  align-items: center;
  gap: 8px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.forecast.border};
  font-family: sans-serif;
  background-color: ${({ theme }) => theme.forecast.redGlassBackground};
  width: fit-content;
  padding: 4px;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`

interface DeleteButtonProps {
  feature: SiteFeaturePrimitive
}

export const DeleteFeatureButton: FC<DeleteButtonProps> = (props) => {
  const { setSelectedFeature, setShowFeaturePopupMenu } =
    useFeatureInteractionContext()
  const { rolodexPatch } = useRolodexEdit()
  const { siteModel, setSiteModel } = useSiteModelContext()

  return (
    <DeleteButton
      onClick={() => {
        rolodexPatch([
          {
            id: siteModel.id,
            delete_data: [`features.${props.feature.id}`],
          },
        ])
        const newSiteModel = {
          ...siteModel,
        }
        delete newSiteModel.data.features[props.feature.id]
        setSiteModel(newSiteModel)
        setShowFeaturePopupMenu(undefined)
        setSelectedFeature(undefined)
      }}>
      <TooltipWrapper label='Delete Feature' side='bottom' offset={5}>
        <Trash2Icon size={16} />
      </TooltipWrapper>
    </DeleteButton>
  )
}
